<template>
  <div>
    <div v-if="isFsTransfer">
      <fs-Account @done="done"></fs-Account>
      <!-- <cyj-Account></cyj-Account> -->
    </div>
    <div v-else>
      <zb-withdrawal v-if="businessType === '203'" :transferData='transferData' @done="done"></zb-withdrawal>
      <zb-transfer v-if="businessType === '301'" :transferData='transferData' @done="done"></zb-transfer>
      <hk-access v-if="transferData.baseAccountType === 'GOODS_ACCOUNT'" :transferData='transferData' @done="done"></hk-access>
      <bzjCash v-if="businessType === 'bzjCash'" :row="transferData" @done="done"/>
    </div>
  </div>
</template>
<script>
import fsAccount from './fs-account'
// import cyjAccount from './cyj-account'
import zbWithdrawal from './fs-account/zb-withdrawal'
import zbTransfer from './fs-account/zb-transfer'
import hkAccess from './fs-account/hk-access'
import bzjCash from './fs-account/bzj-account/cash.vue'
export default {
  name: 'my-account',
  components: {
    fsAccount,
    // cyjAccount,
    zbWithdrawal,
    zbTransfer,
    hkAccess,
    bzjCash,
  },
  data () {
    return {
      activeName: 'fs-account',
      // 附属划转
      isFsTransfer: true,
      // 子组件传递过来的数据
      transferData: {},
      businessType: '',
      // 银行编码
      bankCode: '',
    }
  },
  methods: {
    // 接受子组件传递过来的数据
    done (e, data, type) {
      this.isFsTransfer = e
      this.transferData = data
      this.businessType = type
    },
  }
}
</script>

<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }
</style>
